var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDailymotion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0698 10.3508C9.76322 10.3508 8.7527 11.4945 8.7527 12.8443C8.7527 14.2504 9.76308 15.3191 11.1743 15.3191C12.3589 15.3191 13.3519 14.2692 13.3519 12.8818C13.3519 11.4381 12.3589 10.3508 11.0698 10.3508ZM16 17.9438H13.3345V16.8189C12.5156 17.6813 11.6795 18 10.5645 18C9.43211 18 8.45652 17.6062 7.63768 16.8189C6.55758 15.7877 6 14.4378 6 12.863C6 11.4193 6.52265 10.1257 7.49825 9.11326C8.36934 8.19462 9.43211 7.72583 10.6167 7.72583C11.7491 7.72583 12.6201 8.13824 13.2473 9.00064V4.61373L15.9999 4L16 17.9438Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailymotion);
export default __webpack_public_path__ + "static/media/Dailymotion.f231cf6bb8d33d8562c748099f6254b7.svg";
export { ForwardRef as ReactComponent };